import {freashbook, legal1, legal2, payment1, payment2, payment3, payment4, payroll1, payroll2, payroll3, quickbook, tax1, tax2, tax3, tool1, tool2, tool3, xero } from "../assets/imagesPath";

export const affiliates = [
   {
      title:'Accounting & Bookkeeping Software',
      images:[
         quickbook,
         xero,
         freashbook,
      ]
   },
   {
      title:'Payroll and HR Services',
      images:[
         payroll1,
         payroll2,
         payroll3
      ]
   },
   {
      title:'Payment Processing and Banking',
      images:[
         payment1,
         payment2,
         payment3,
         payment4,
      ]
   },
   ,
   {
      title:'Legal Support and Documentation',
      images:[
        legal1,
        legal2
      ]
   },
   {
      title:'Tax and Compliance',
      images:[
         tax1,
         tax2,
         tax3
      ]
   },
   {
      title:'Other Tools for Small Businesses',
      images:[
         tool1,
         tool2,
         tool3
      ]
   },
   
    
  ];